<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="850px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div v-loading="loading">
      <el-tabs
        v-model="selectedTab"
        tab-position="top"
      >
        <el-tab-pane
          label="Alapadatok"
          name="Alapadatok"
        >
          <basic-data-form
            ref="basicData"
            :ownCompany="ownCompany"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Cím"
          name="Cim"
        >
          <address-form
            ref="addressForm"
            :billingAddr="ownCompany.billing_address"
            :deliveryAddr="ownCompany.delivery_address"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Számlaszámok"
          name="Számlaszámok"
        >
          <bank-accounts-form
            :accounts="ownCompany.bank_accounts"
            @change="onAccountChange"
            @add="onAccountAdd"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Számlázz.hu"
          name="Számlázz.hu"
        >
          <span slot="label">
            <img :src="SzamlazzHuSVG"/> Számlázz.hu
          </span>

          <szamlazzhu-form
            ref="szamlazzhu"
            :ownCompany="ownCompany"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import BasicDataForm from './forms/BasicData';
import AddressForm from './forms/Address';
import BankAccountsForm from './forms/BankAccounts';
import SzamlazzhuForm from './forms/SzamlazzhuForm';

export default {
  components: {
    BasicDataForm,
    AddressForm,
    BankAccountsForm,
    SzamlazzhuForm,
  },
  props: ['type', 'ownCompanyId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      selectedTab: 'Alapadatok',
      ownCompany: {
        billing_address: {},
        delivery_address: {},
        bank_accounts: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
      },
      SzamlazzHuSVG: require('../../../assets/szamlazzhu-icon.svg')
    };
  },
  computed: {
    title() {
      if (this.type === 'add') {
        return 'Új saját cég';
      } else if (this.type === 'update') {
        return 'Saját cég módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    if (this.ownCompanyId) {
      this.ownCompany = await this.$store.dispatch('ownCompany/fetch', this.ownCompanyId);
    }
    this.loading = false;
  },
  methods: {
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/data/own-companies');
        })
        .catch(() => {
        });
    },
    onAccountChange(accounts) {
      this.ownCompany.bank_accounts = accounts;
    },
    onAccountAdd(account) {
      this.ownCompany.bank_accounts.push(account);
    },

    async store() {
      this.$refs.basicData.$refs.basicDataForm.validate(async valid => {
        if (valid) {
          this.$refs.addressForm.$refs.billingAddressForm.validate(async valid => {
            if (valid) {
              this.$refs.addressForm.$refs.deliveryAddressForm.validate(async valid => {
                if (valid) {
                  this.$refs.szamlazzhu.$refs.szamlazzhuForm.validate( async valid => {
                    if(valid){
                      this.buttonLoading = true;
                      try {
                        const data = Object.assign({}, this.$refs['basicData'].basicData);
                        data.billing_address = this.$refs['addressForm'].billingAddress;
                        data.billing_address.country_id = data.billing_address.country.id;
                        data.billing_address.county_id = data.billing_address.county.id;
                        data.delivery_address = this.$refs['addressForm'].deliveryAddress;
                        data.delivery_address.county_id = data.delivery_address.county.id;
                        data.delivery_address.country_id = data.delivery_address.country.id;
                        data.bank_accounts = this.ownCompany.bank_accounts;
                        data.szamlazz_agent_key = this.$refs['szamlazzhu'].formData.szamlazz_agent_key
                        data.szamlazz_enabled = this.$refs['szamlazzhu'].formData.szamlazz_enabled

                        if (this.type === 'add') {
                          await this.$store.dispatch('ownCompany/create', data);
                        } else if (this.type === 'update') {
                          await this.$store.dispatch('ownCompany/update', data);
                        }
                        this.$store.dispatch('ownCompany/fetchAll');
                        this.buttonLoading = false;
                        this.$router.replace('/data/own-companies');
                      } catch (e) {
                      }
                      this.buttonLoading = false;
                    } else {
                      this.selectedTab = 'Számlázz.hu';
                    }
                  })
                } else {
                  this.selectedTab = 'Cim';
                }
              });
            } else {
              this.selectedTab = 'Cim';
            }
          });
        } else {
          this.selectedTab = 'Alapadatok';
        }
      });
    }
  },
};
</script>
